<SettingsLayout page='settings' label="Opciones de configuración">
  <h1>Opciones de configuración</h1>

  <SettingsList>
    <SettingsListRow>
      <SettingsListButton href="/settings/general" label="General"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/instances" label="Instancias"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/wellness" label="Bienestar"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/hotkeys" label="Atajos de teclado"/>
    </SettingsListRow>
    <SettingsListRow>
    <SettingsListButton href="#" on:click="reload(event)" label="Recargar"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/about" label="Acerca de Pinafore"/>
    </SettingsListRow>
  </SettingsList>

</SettingsLayout>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import SettingsList from '../../_components/settings/SettingsList.html'
  import SettingsListRow from '../../_components/settings/SettingsListRow.html'
  import SettingsListButton from '../../_components/settings/SettingsListButton.html'

  export default {
    components: {
      SettingsLayout,
      SettingsList,
      SettingsListRow,
      SettingsListButton
    },
    methods: {
      reload (event) {
        event.preventDefault()
        document.location.reload(true)
      }
    }
  }
</script>
